"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MissingContentViewWrapper = exports.CompanyName = exports.CompaniesListGridWrapper = exports.CompanyCardContent = exports.CompanyCard = exports.ImageBlock = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const elements_1 = require("@src/components/elements");
exports.ImageBlock = (0, styled_components_1.default)(elements_1.Link) `
	background: ${({ theme }) => theme.color.white};
	width: 100%;
	height: 200px;
	overflow: hidden;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	position: relative;

	&:hover {
		& > img,
		svg {
			transform: scale(1.1);
			opacity: 0.5;
		}
	}

	& > img {
		transition: 0.3s ease-in-out;
		max-width: 100%;
		max-height: 100%;
	}

	& > svg {
		max-width: 50%;
		max-height: 100%;
		transition: 0.3s ease-in-out;
		color: ${({ theme }) => theme.color.gray5};
	}
`;
exports.CompanyCard = styled_components_1.default.div `
	width: 200px;
	background: white;
	border-radius: ${({ theme }) => theme.borderRadius.base};
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: center;
	transition: 0.3s ease-in-out;
	position: relative;

	&& {
		color: ${({ theme }) => theme.color.black};
	}
`;
exports.CompanyCardContent = styled_components_1.default.div `
	flex: 1;
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	align-items: center;
	padding: 1rem;
`;
exports.CompaniesListGridWrapper = styled_components_1.default.div `
	padding: 2rem;
	display: grid;
	justify-content: center;
	justify-items: stretch;
	align-items: stretch;
	grid-template-columns: repeat(auto-fill, 200px);
	row-gap: 10px;
	column-gap: 10px;
`;
exports.CompanyName = (0, styled_components_1.default)(elements_1.Link) `
	margin-bottom: 0.75rem;
	font-size: 0.85rem;
	font-weight: 500;
	cursor: pointer;
	align-self: flex-start;

	&& {
		color: ${({ theme }) => theme.color.black};
	}

	&:hover {
		color: ${({ theme }) => theme.color.gray9};
	}
`;
exports.MissingContentViewWrapper = styled_components_1.default.div `
	grid-column: 1 / -1;
`;
